module.exports = __webpack_public_path__ + "img/green_089.ab35f80c.png";